/**
 * ⚠️  AUTO-GENERATED — DO NOT EDIT MANUALLY ⚠️
 *
 * Generated by: scripts/preload-query-batch-classifier/index.mjs
 *
 * Per-region SSR preloaded GraphQL query classification using bitmap encoding.
 * Q contains all query names (sorted, with index comments). R maps each SSR
 * region to a hex bitmap where bit i = 1 means Q[i] is fast (batchable).
 *
 * Per-region classification summary (fast/slow/excluded counts) is
 * embedded in the PR description.
 *
 * Thresholds (prod): p90 ≤ 300ms | p95 ≤ 500ms | p99 ≤ 1000ms | min n=100
 * Thresholds (staging): p90 ≤ 600ms | p95 ≤ 1000ms | p99 ≤ 2000ms | min n=100
 * Lookback: last 3 business days
 * Generated: 2026-05-06T03:05:43.998Z
 */

// prettier-ignore
export const Q: readonly string[] = [
	'ActiveCommentsQuery', // 0
	'ApprovalsContextApprovalsDataQuery', // 1
	'ArchivedPageBannerV2ArchivedPageBannerContainerQuery', // 2
	'ArchivedPageBannerV2ArchivedPageBannerQuery', // 3
	'BlogTreeRootComponentQuery', // 4
	'CollabDraftQuery', // 5
	'CollabDraftWithRelevanceQuery', // 6
	'ContentBlogUnifiedQuery', // 7
	'ContentHeaderPresenceContentSettingsQuery', // 8
	'ContentHeaderUnifiedQuery', // 9
	'ContentPrerequisitesQuery', // 10
	'ContentRedirectQuery', // 11
	'ContentTypesHeaderQuery', // 12
	'ContentUnifiedQuery', // 13
	'ContentUnifiedWithSpaceKeyQuery', // 14
	'CookieConsentPreferences', // 15
	'CoverPictureQuery', // 16
	'CustomHeaderFooterQuery', // 17
	'DatabaseContainerQuery', // 18
	'EditContentButtonQuery', // 19
	'EditorContentStateQuery', // 20
	'EditorPreferencesQuery', // 21
	'EmojiTitleQuery', // 22
	'EndOfPageRecommendationQuery', // 23
	'FetchPreFilteredForgeAppsQuery_confluence_contentBylineItem', // 24
	'FetchPreFilteredForgeAppsQuery_confluence_spacePage', // 25
	'FetchPreFilteredForgeAppsQuery_xen_macro', // 26
	'FollowingFeedWithSortByStorageSnippetsQuery', // 27
	'FooterCreateButtonsQuery', // 28
	'ForgeExtensionList', // 29
	'GlobalNavigationComponentQuery', // 30
	'GrantAccessDialogLoaderQuery', // 31
	'HomeRecentWorkQuery', // 32
	'InlineCommentsFocusedInlineCommentQuery', // 33
	'LegacyMacroRendererQueryBodyQuery', // 34
	'LivePagesByLineLastUpdatedQuery', // 35
	'LocalStorageQuery', // 36
	'NativeCollabQuery', // 37
	'NotFoundContainerQuery', // 38
	'NotificationsButtonQuery', // 39
	'ObjectCommentContainerPreloadObjectCommentsQuery', // 40
	'PageRestrictionsContextQuery', // 41
	'PageTreeQuery', // 42
	'PageTreeQueryWithSpaceKeyQuery', // 43
	'PermissionCheckAddCommentQuery', // 44
	'PersistentInviteEligibleQuery', // 45
	'PersonalizedTemplatesV2AllTemplatesQuery', // 46
	'PopularFeedWithTimeGranularityStorageSnippetsQuery', // 47
	'Preferences', // 48
	'PremiumTrialEotQuery', // 49
	'ReactionsContentQuery', // 50
	'RecentlyUpdatedMacroQuery', // 51
	'RendererContentStateQuery', // 52
	'RestrictedPageWithCanViewQuery', // 53
	'ScreenQuery', // 54
	'SiteInformationQuery', // 55
	'SmartCreateFeedbackBannerQuery', // 56
	'SmartCreatePageEditorDataWrapperComponentQuery', // 57
	'SpaceNavigationQuery', // 58
	'SpaceOverviewIdQuery', // 59
	'SpaceOverviewQuery', // 60
	'SpaceOverviewSwitcherQuery', // 61
	'SpaceQuery', // 62
	'SpaceRestrictionCheckQuery', // 63
	'ThemeQuery', // 64
	'TopNavigationQuery', // 65
	'UserSettingsQuery', // 66
	'ViewSpaceExternalCollaboratorsDialogQuery', // 67
	'WebItemLocationQuery_page.metadata.banner', // 68
	'WebItemLocationQuery_system.content.byline', // 69
	'WebItemLocationQuery_system.header_left', // 70
	'WebItemLocationQuery_system.header_left_system.user', // 71
	'WebPanelLocationQuery_atl.footer', // 72
	'WebPanelLocationQuery_atl.general', // 73
	'WebPanelLocationQuery_atl.general_atl.footer', // 74
	'WebPanelLocationQuery_atl.page.content.footer.actions', // 75
	'WelcomeMessagesQuery', // 76
	'WhiteboardUnifiedQuery', // 77
	'contentAppearanceQuery', // 78
	'contentSmartLinksORS', // 79
	'fetchMentionsProviderDataQuery', // 80
	'graphqlHelpersDSPIsActionEnabledForContentQuery', // 81
	'graphqlHelpersFetchMediaTokenQuery', // 82
	'multiMacroQueryQuery', // 83
	'multiMacroQueryWithAppKeyQuery', // 84
	'onboardingStateGetOnboardingStateQuery', // 85
	'onboardingStateGetOnboardingStateQuery_aifc-onboarding_hasSeenAIFCSpotlight_8', // 86
	'onboardingStateGetOnboardingStateQuery_auto-page-emoji_emojiTitleDiscovered', // 87
	'onboardingStateGetOnboardingStateQuery_create-with-rovo-announcement-splash_hasSeenSplashModal', // 88
	'onboardingStateGetOnboardingStateQuery_creation-focused-nav_shouldShowSpotlight_2', // 89
	'onboardingStateGetOnboardingStateQuery_creation-focused-nav_shouldShowSpotlight_4', // 90
	'onboardingStateGetOnboardingStateQuery_creation-focused-nav_shouldShowSpotlight_6', // 91
	'onboardingStateGetOnboardingStateQuery_cross-join-nth-user-onboarding_trendingPages', // 92
	'onboardingStateGetOnboardingStateQuery_editor-state_editorOnboardingEligiblity_12', // 93
	'onboardingStateGetOnboardingStateQuery_land-users-in-editor-with-revamped-bpqa_revampedBpqaShownAt', // 94
	'onboardingStateGetOnboardingStateQuery_onboarding-intent-experiences_onboardingIntentExperienceClosed_18', // 95
	'onboardingStateGetOnboardingStateQuery_onboarding-origin-state_attributes_67', // 96
	'onboardingStateGetOnboardingStateQuery_onboarding-state_isFoundingAdmin', // 97
	'onboardingStateGetOnboardingStateQuery_onboarding-state_isFoundingAdmin_10', // 98
	'onboardingStateGetOnboardingStateQuery_onboarding-state_isFoundingAdmin_5', // 99
	'onboardingStateGetOnboardingStateQuery_onboarding-state_isFoundingAdmin_6', // 100
	'onboardingStateGetOnboardingStateQuery_onboarding-state_nthUserOnboardingCompletedTimestamp', // 101
	'onboardingStateGetOnboardingStateQuery_storage-enforcement-state_flagsDismissedFreeThreshold_152', // 102
	'pageButtons', // 103
	'preloadAutohighlightsQuery', // 104
	'preloadContentSmartLinksQuery', // 105
	'preloadCreateSpaceQuery', // 106
	'preloadEditButtonWithSpaceKeyQuery', // 107
	'preloadEditorNodeDataProvidersDataQuery', // 108
	'preloadLegacyBridgeQuery', // 109
	'preloadOperationsQuery', // 110
	'preloadPageStatusQueryDataQuery', // 111
	'preloadPersonalSpaceDetailsQuery', // 112
	'preloadShareAndRestrictButtonQuerySpaceOverviewQuery', // 113
	'preloadSpaceBlogCountQuery', // 114
	'preloadTemplatesCollectionEligibleQuery', // 115
	'requireSuperBatchFrontendResourceRenderQuery', // 116
	'rightPanel', // 117
	'searchCombinedConfig', // 118
	'searchResults', // 119
	'sidenavSmartLinksORS', // 120
	'useAnalyticsByLineQuery', // 121
	'useAudioContentQuery', // 122
	'useBlogPostsQueryQuery', // 123
	'useConfluenceStandardToPremiumExperimentQuery', // 124
	'useContentClassificationContentDataClassificationQuery', // 125
	'useEditorContentModeValueQuery', // 126
	'useEmojiEverSetPropertyQuery', // 127
	'useFabricEligibilityMigrationQuery', // 128
	'useFeatureDiscoveryFeatureDiscoveryQuery', // 129
	'useFeedTypeSelectorRefreshQuery', // 130
	'useFollowingFeedWithSortByStorageFeedContentQuery', // 131
	'useGetCurrentStorageUsageQuery', // 132
	'useGetTeamAndSubanchorGetPersonalSpaceKeyQuery', // 133
	'useGetTeamAndSubanchorGetSubanchorsAGGQuery', // 134
	'useHomeWidgetStateQuery', // 135
	'useIsEligibleForNthUserHomeOnboardingLicensedUserCountQuery', // 136
	'useIsLoomEntryPointsEnabledQuery', // 137
	'useIsUserViewingSpaceAsAnonQuery', // 138
	'useLicensedProductsQueryForGlobalAppShortcutsQuery', // 139
	'useLoomTenantProvisionStatusQuery', // 140
	'usePopularFeedWithTimeGranularityStorageQuery', // 141
	'usePreloadCommentButtonQuery', // 142
	'useReadTimeQuery', // 143
	'useRegisterAdminAnnouncementBannerQuery', // 144
	'useShareAndRestrictButtonDataQuery', // 145
	'useShortcutsSpaceNavigationQuery', // 146
	'useSpaceBaseQueryBaseQuery', // 147
	'useSpaceDetailQuery', // 148
	'useSpaceEnabledContentTypesQuery', // 149
	'useSpaceViewsDataSpaceRootQuery', // 150
	'useSpaceViewsOptionsPersistenceQuery', // 151
	'useSpacesDataAnonymousSpacesQuery', // 152
	'useSpacesDataMyVisitedSpacesQuery', // 153
	'useSpacesDataStarredSpacesQuery', // 154
	'useTitleContentPropertiesForEditorQuery', // 155
	'useTitleContentPropertiesForPublishedPagePreloadHomepageIdQuery', // 156
	'useTitleContentPropertiesForPublishedPageQuery', // 157
	'useUserByLicensedProductsQuery', // 158
];

// prettier-ignore
export const R: Readonly<Record<string, string>> = {
	'prod-apne': '557f7b77f85ef2dd7f6be76dffff03f6a7deff3c', /* 114 fast, 19 slow, 16 excl */
	'prod-apne2': '557f7b77fa5ef2dd7f6be7edffffaff4f7deff7c', /* 122 fast, 17 slow, 43 excl */
	'prod-apse': 'ddff7bf7fb5ef6df7f6bf7edffffaff6f7deff7d', /* 132 fast, 12 slow, 14 excl */
	'prod-apse2': 'fdff7bf7fa5ef6df7f7bf7edffffbff6e7deff7f', /* 134 fast, 12 slow, 66 excl */
	'prod-apsouth': '15ff7b77fa5ef2df7f7bf7edffffaff6f7deff7e', /* 127 fast, 13 slow, 43 excl */
	'prod-cacentral': 'fdff7b77fb7ef6df7f7bf7edffffaff6f7dfff7e', /* 135 fast, 7 slow, 13 excl */
	'prod-east': 'fdff7ff7fb7ef7df7f7bf7edffffbff4f7dfff7f', /* 139 fast, 11 slow, 119 excl */
	'prod-eucentral': 'ffff7ff7fa5ef7df7f6bf7fdffffbff4f7deff7d', /* 136 fast, 15 slow, 88 excl */
	'prod-eucentral2': '68dd7302f00a62d84f60e56dbc5c0fb0f60add3c', /* 79 fast, 61 slow, 12 excl */
	'prod-euwest': 'ffff7ff7fb7ef7df7f7bf7fdffffbff4f7dfff7f', /* 141 fast, 11 slow, 119 excl */
	'prod-euwest2': 'fdff7bf7fb7ef6df7f7bf7edffffaff6f7deff7e', /* 135 fast, 8 slow, 20 excl */
	'prod-west2': '9dff7ff7fe7ef7df7f7bf7edffffbff6f7dfff7d', /* 137 fast, 11 slow, 136 excl */
	'stg-east': 'f6f3fb77b87ffdbdffdffffbfeff1bffffdfff7e', /* 135 fast, 4 slow, 47 excl */
};
